import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

interface ConfirmReferralSimpleDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  facilityName?: string | null;
}

export const ConfirmReferralSimpleDialog: React.FC<
  ConfirmReferralSimpleDialogProps
> = ({ open, onClose, onConfirm, isLoading, facilityName }) => {
  const facilityLabel = facilityName ?? 'this facility';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Referral</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Confirm referral for {facilityLabel}? All other recipients will be
          closed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          loading={isLoading}
          variant="contained"
          color="primary"
        >
          Confirm Referral
        </Button>
      </DialogActions>
    </Dialog>
  );
};
